// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Layout4-bannerLayoutContainer-CH1YS {
	min-height: 508px;
	height: auto;
	position: relative;
}

.Layout4-bannerBackgroundImage-zqzwm {
	background-size: cover;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	position: absolute;
	right: 0;
	-o-object-fit: cover;
	   object-fit: cover;
	background-repeat: no-repeat;
	background-position: top center;
	-webkit-transition: all 0.1s ease;
	transition: all 0.1s ease;
	-webkit-box-shadow: inset 0px 0px 10px var(--primary-box-shadow);
	        box-shadow: inset 0px 0px 10px var(--primary-box-shadow);
}

.Layout4-searchFormContainer-z2FjN {
	position: relative;
	height: 100%;
	margin: 0 auto;
	max-width: var(--max-container-width);
	padding: 125px 15px;
}

.Layout4-searchFormWrap-gITH7 {
	color: var(--secondary-foreground);
	background: var(--background-primary);
	padding: 30px;
	border-radius: 15px;
	width: 100%;
	max-width: 450px;
	-webkit-box-shadow: 1px 5px 10px var(--primary-box-shadow);
	        box-shadow: 1px 5px 10px var(--primary-box-shadow);
}

.Layout4-searchFormWrap-gITH7 h1 span {
	margin: 0 0 10px;
}

.Layout4-searchFormWrap-gITH7 h1 {
	margin: 0;
	font-weight: 600;
	font-size: 26px;
	color: var(--primary-foreground);
}

@media screen and (max-width: 767px) {
	.Layout4-searchFormContainer-z2FjN {
		padding: 80px 15px;
	}

	.Layout4-bannerLayoutContainer-CH1YS {
		min-height: 400px;
	}

	.Layout4-searchFormWrap-gITH7 {
		padding: 20px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Home/Layout4/Layout4.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;CACjB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,sBAAsB;CACtB,WAAW;CACX,YAAY;CACZ,MAAM;CACN,OAAO;CACP,kBAAkB;CAClB,QAAQ;CACR,oBAAiB;IAAjB,iBAAiB;CACjB,4BAA4B;CAC5B,+BAA+B;CAC/B,iCAAyB;CAAzB,yBAAyB;CACzB,gEAAwD;SAAxD,wDAAwD;AACzD;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,qCAAqC;CACrC,mBAAmB;AACpB;;AAEA;CACC,kCAAkC;CAClC,qCAAqC;CACrC,aAAa;CACb,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,0DAAkD;SAAlD,kDAAkD;AACnD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,SAAS;CACT,gBAAgB;CAChB,eAAe;CACf,gCAAgC;AACjC;;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,aAAa;CACd;AACD","sourcesContent":[".bannerLayoutContainer {\n\tmin-height: 508px;\n\theight: auto;\n\tposition: relative;\n}\n\n.bannerBackgroundImage {\n\tbackground-size: cover;\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tposition: absolute;\n\tright: 0;\n\tobject-fit: cover;\n\tbackground-repeat: no-repeat;\n\tbackground-position: top center;\n\ttransition: all 0.1s ease;\n\tbox-shadow: inset 0px 0px 10px var(--primary-box-shadow);\n}\n\n.searchFormContainer {\n\tposition: relative;\n\theight: 100%;\n\tmargin: 0 auto;\n\tmax-width: var(--max-container-width);\n\tpadding: 125px 15px;\n}\n\n.searchFormWrap {\n\tcolor: var(--secondary-foreground);\n\tbackground: var(--background-primary);\n\tpadding: 30px;\n\tborder-radius: 15px;\n\twidth: 100%;\n\tmax-width: 450px;\n\tbox-shadow: 1px 5px 10px var(--primary-box-shadow);\n}\n\n.searchFormWrap h1 span {\n\tmargin: 0 0 10px;\n}\n\n.searchFormWrap h1 {\n\tmargin: 0;\n\tfont-weight: 600;\n\tfont-size: 26px;\n\tcolor: var(--primary-foreground);\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFormContainer {\n\t\tpadding: 80px 15px;\n\t}\n\n\t.bannerLayoutContainer {\n\t\tmin-height: 400px;\n\t}\n\n\t.searchFormWrap {\n\t\tpadding: 20px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bannerLayoutContainer": `Layout4-bannerLayoutContainer-CH1YS`,
	"bannerBackgroundImage": `Layout4-bannerBackgroundImage-zqzwm`,
	"searchFormContainer": `Layout4-searchFormContainer-z2FjN`,
	"searchFormWrap": `Layout4-searchFormWrap-gITH7`
};
module.exports = ___CSS_LOADER_EXPORT___;
